/**
 * 资源中心的板块配置：把后端频道 key（resource_xxx）和前台好看的 URL 短名对应起来，
 * 顶部导航、板块列表页、内容管理列表页的"前台URL"列都从这里取，只在一个地方维护。
 */
export interface ResourceChannelConfig {
  key: string; // 后端 ContentChannel.key
  routeSlug: string; // 前台路由用的短名，如 /resources/warehouse-tour
  label: string;
}

export const RESOURCE_CHANNELS: ResourceChannelConfig[] = [
  { key: 'resource_warehouse_tour', routeSlug: 'warehouse-tour', label: '仓库实拍' },
  { key: 'resource_knowledge_base', routeSlug: 'knowledge-base', label: '知识库' },
  { key: 'resource_industry_news', routeSlug: 'industry-news', label: '行业资讯' },
  { key: 'resource_sharing', routeSlug: 'sharing', label: '资源共享' },
];

export function channelKeyToRouteSlug(channelKey: string): string {
  return RESOURCE_CHANNELS.find((c) => c.key === channelKey)?.routeSlug || '';
}

export function routeSlugToChannelKey(routeSlug: string): string {
  return RESOURCE_CHANNELS.find((c) => c.routeSlug === routeSlug)?.key || '';
}

export function isResourceChannelKey(channelKey: string): boolean {
  return RESOURCE_CHANNELS.some((c) => c.key === channelKey);
}
